import {
  getErrorMsgAndCode,
  validateInput,
  checkPasswordInput,
  compressImage,
} from "./FrontendHelpers";
import api from "./axios";
import { t } from "i18next";

const checkInput = (username, email, firstName, lastName) => {
  return validateInput([
    {
      Name: "Username",
      Type: "username",
      Value: username,
      MinLength: 3,
      Message: t("validation.The username field cannot be empty.", {
        ns: "error",
      }),
    },

    {
      Name: "Email",
      Type: "email",
      Value: email,
      MinLength: 0,
    },
    {
      Name: "First Name",
      Type: "string",
      Value: firstName,
      Message: t("validation.You must enter a first name.", { ns: "error" }),
      MinLength: 0,
      MaxLengthType: "name",
    },
    {
      Name: "Last Name",
      Type: "string",
      Value: lastName,
      Message: t("validation.You must enter a last name.", { ns: "error" }),
      MinLength: 0,
      MaxLengthType: "name",
    },
  ]);
};

const checkLoginInput = (usernameOrEmail, password) => {
  return validateInput([
    {
      Name: "Username",
      Type: "string",
      Value: usernameOrEmail,
      MinLength: 3,
      Message: t("validation.The username field cannot be empty.", {
        ns: "error",
      }),
    },
    {
      Name: "Password",
      Type: "passwordLogin",
      Value: password,
      MinLength: 6,
      Message: t("validation.The password field cannot be empty.", {
        ns: "error",
      }),
    },
  ]);
};

const checkEditInput = (username, firstName, lastName) => {
  return validateInput([
    {
      Name: "Username",
      Type: "string",
      Value: username,
      MinLength: 3,
      Message: t("validation.The username field cannot be empty.", {
        ns: "error",
      }),
    },
    {
      Name: "First Name",
      Type: "string",
      Value: firstName,
      Message: t("validation.You must enter a first name.", { ns: "error" }),
      MinLength: 0,
    },
    {
      Name: "Last Name",
      Type: "string",
      Value: lastName,
      Message: t("validation.You must enter a last name.", { ns: "error" }),
      MinLength: 0,
    },
  ]);
};

export async function Login(usernameOrEmail, password) {
  try {
    const errorObj = checkLoginInput(usernameOrEmail, password);
    if (errorObj.errCode !== 0) return [null, errorObj];

    const data = { usernameOrEmail, password };
    const response = await api.post("/users/login", data);
    let result;

    result = response.data;
    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function GoogleLoginUser(googleToken) {
  try {
    const response = await api.post("/users/auth/google", {
      token: googleToken,
    });
    const result = response.data;

    localStorage.setItem("token", result.token);

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function Logout() {
  try {
    await api.post("/users/logout");
    return [null, null];
  } catch (err) {
    const errorObj = getErrorMsgAndCode(err);
    return [null, errorObj];
  } finally {
    localStorage.removeItem("token");
  }
}
export async function Register(username, password, email, firstName, lastName) {
  try {
    const errorObj = checkInput(username, email, firstName, lastName);
    if (errorObj.errCode !== 0) return [null, errorObj];
    const passErrorObj = checkPasswordInput(password);
    if (passErrorObj !== true) return [null, passErrorObj];

    const data = { username, password, email, firstName, lastName };
    const response = await api.post("/users/register", data);
    await UpdateRegisterStage(1);

    const result = response.data;
    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function UpdateRegisterStage(stage) {
  try {
    const data = { stage };
    const response = await api.post("/users/updateRegisterStage", data);

    return [response.data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function ResendRegisterEmail(email) {
  try {
    const data = { email };
    await api.post("/users/resendRegisterEmail", data);

    return [null, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function VerifyUserRequestByToken(token) {
  try {
    const data = { token };
    await api.post("/users/verify", data);
    return [null, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function SendPasswordResetEmail(email) {
  try {
    const data = { email };
    await api.post("/users/sendPasswordResetEmail", data);
    return [null, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function VerifyPasswordResetByToken(token) {
  try {
    const data = { token };
    await api.post("/users/verifyPasswordReset", data);
    return [null, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function ResetPassword(token, newPassword) {
  try {
    const data = { token, newPassword };
    await api.post("/users/resetPassword", data);
    return [null, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function ChangePassword(currentPassword, newPassword) {
  try {
    const data = { currentPassword, newPassword };
    const response = await api.post("/users/changePassword", data);
    return [response.data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetUserInfo() {
  try {
    const response = await api.get("/users/getUserInfo");
    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetUserPermissions() {
  try {
    const response = await api.get("/users/getUserPermissions");
    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetAllAvailablePermissions() {
  try {
    const response = await api.get("/users/getAllAvailablePermissions");
    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function CheckIfLoggedIn() {
  try {
    const [data, error] = await GetUserInfo();
    if (error?.errCode === 401) return [false, null];
    if (error) return [false, error];
    return [true, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [false, errorObj];
  }
}

export async function EditUserInfo(
  firstName,
  lastName,
  username,
  image,
  removeImage = false
) {
  try {
    const errorObj = checkEditInput(username, firstName, lastName);
    if (errorObj.errCode !== 0) return [null, errorObj];

    const data = new FormData();
    if (image) {
      const compressedImage = await compressImage(image);
      data.append("image", compressedImage, compressedImage.name);
    }
    data.append("firstName", firstName);
    data.append("lastName", lastName);
    data.append("username", username);
    data.append("removeImage", removeImage);

    const response = await api.post("/users/editUserInfo", data);
    const result = response.data;
    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function CheckForPermission(Permission) {
  try {
    const data = { Permission };
    const response = await api.post("/users/checkForPermission", data);
    const result = response.data;

    return [result.permission, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function LeaveCompany() {
  try {
    await api.get("/users/leaveCompany");

    await Logout();

    return [null, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function DeleteAccount() {
  try {
    await api.get("/users/deleteAccount");

    await Logout();

    return [null, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetAccessiblePages() {
  try {
    const response = await api.get("/users/getAccessiblePages");
    const result = response.data;
    console.log("RESULT FOR ACCESSIBLE PAGES", result);
    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
